import { LocationState } from "@/redux/slices/location";

import slugify from "./slugifyURLComponent";

export const navLinkRetailerUrlBuilder = (
  userLocation: LocationState,
  directory: string,
) =>
  userLocation?.state || (userLocation?.state && userLocation?.city)
    ? `/${directory}/${slugify(userLocation.state)}/${slugify(userLocation.city)}`
    : `/${directory}/arizona/phoenix`;
